import { render } from "./RelatorioEvolucaoCarteiraView.vue?vue&type=template&id=0e5e9770"
import script from "./RelatorioEvolucaoCarteiraView.vue?vue&type=script&lang=js"
export * from "./RelatorioEvolucaoCarteiraView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__